import React, { useState } from 'react';
import Modal from './Modal';
import './styles/components.css';

const CreateButton = ({ formConfig, onCreate }) => {
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const handleChange = e => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setFeedback(null);
    await onCreate(values, success => {
      setLoading(false);
      setFeedback(success ? 'Creado correctamente' : 'Error al crear');
      if (success) {
        setValues({});
        setTimeout(() => {
          setOpen(false);
          setFeedback(null);
        }, 1000);
      }
    });
  };

  return (
    <>
      <button
        className="create-btn create-btn-float"
        onClick={() => setOpen(true)}
        title="Crear nuevo"
        type="button"
      >
        +
      </button>
      {open && (
        <Modal
          title="Crear Nuevo"
          onClose={() => setOpen(false)}
          actions={
            <div className="modal-actions">
              <button type="submit" className="create-btn" disabled={loading} form="create-form">
                {loading ? 'Guardando...' : 'Guardar'}
              </button>
              <button type="button" className="close-btn" onClick={() => setOpen(false)}>
                Cerrar
              </button>
            </div>
          }
        >
          <form id="create-form" onSubmit={handleSubmit}>
            {formConfig.map(field => (
              <div key={field.name} style={{ marginBottom: 12 }}>
                <input
                  type={field.type}
                  name={field.name}
                  value={values[field.name] || ''}
                  onChange={handleChange}
                  required
                  placeholder={`Ingrese ${field.label.toLowerCase()}`}
                />
              </div>
            ))}
            {feedback && <div style={{ marginTop: 10 }}>{feedback}</div>}
          </form>
        </Modal>
      )}
    </>
  );
};

export default CreateButton;
